import { StyleSheet, type ViewStyle } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const pointerEventsStyles = StyleSheet.create<PointerEventsStyles>({
  auto: { pointerEvents: 'auto' },
  none: { pointerEvents: 'none' },
  'box-none': { pointerEvents: 'box-none' },
  'box-only': { pointerEvents: 'box-only' },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type PointerEvents = NonNullable<ViewStyle['pointerEvents']>;
type PointerEventsStyles = {
  [Value in PointerEvents]: { pointerEvents: Value; opacity?: number };
};
